<mat-select [tabIndex]="tabIndex" [formControl]="selectCtrl" [compareWith]="compareWith"
  (selectionChange)="onSelectionChange()" *ngIf="showOptions">
  <mat-option [value]="section" *ngFor="let section of sections">{{ section.name }}</mat-option>
</mat-select>

<input matInput readonly disabled type="text" [matTooltip]="'GENERAL.NO_RESULT_FOUND' | translate" *ngIf="showNotFound">

<input matInput readonly disabled type="text" [matTooltip]="'GENERAL.PLEASE_SELECT_BOARD' | translate" *ngIf="showSelectBoard">

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>